import { LANGUAGE_ORDER } from "./shared";

// Claude: alpha-tester feedback — "when a search is done with target 'all languages', it is not
// Claude: clear... which words across the languages are related." Every Word row already carries
// Claude: wordEnglish, the backbone term the backend itself uses to fetch every language's
// Claude: equivalent (see soek/advanced in views.py) — this just groups on that same key instead of
// Claude: discarding it once the results reach the frontend. Groups are returned in first-seen
// Claude: order; each group's own rows are sorted into LANGUAGE_ORDER so every card lists languages
// Claude: consistently.
export function groupResultsByWordEnglish(phrases) {
  const groups = new Map();
  phrases.forEach((phrase) => {
    const key = phrase.wordEnglish;
    if (!groups.has(key)) {
      groups.set(key, []);
    }
    groups.get(key).push(phrase);
  });

  return Array.from(groups.entries()).map(([wordEnglish, items]) => ({
    wordEnglish,
    items: [...items].sort(
      (a, b) => LANGUAGE_ORDER.indexOf(a.language) - LANGUAGE_ORDER.indexOf(b.language)
    ),
  }));
}

// Claude: alpha-tester feedback — with "Allow for spelling mistakes" on, "searching 'variance'
// Claude: lists alliance, deviance and valence before the exact match, which comes 7th." Per
// Claude: instruction, only for fuzzy searches: every row of a wordEnglish group that contains an
// Claude: exact (case-insensitive, trimmed) match of the searched term in the search's source
// Claude: language is moved to the front; everything else keeps the order the backend returned it
// Claude: in (a stable partition, not a re-sort). Applied once, when the results arrive, so the
// Claude: stored order — and thus groupResultsByWordEnglish's first-seen group order — doesn't
// Claude: change as the user edits the search box afterwards.
export function exactMatchesFirst(phrases, searchTerm, sourceLanguage) {
  const target = (searchTerm || "").trim().toLowerCase();
  if (!target) {
    return phrases;
  }
  const exactGroups = new Set(
    phrases
      .filter(
        (phrase) =>
          phrase.language === sourceLanguage &&
          (phrase.word || "").trim().toLowerCase() === target
      )
      .map((phrase) => phrase.wordEnglish)
  );
  if (exactGroups.size === 0) {
    return phrases;
  }
  return [
    ...phrases.filter((phrase) => exactGroups.has(phrase.wordEnglish)),
    ...phrases.filter((phrase) => !exactGroups.has(phrase.wordEnglish)),
  ];
}
